<template>
  <div>
    <!-- 卡片视图 -->
    <el-card class="box-card">
      <div v-loading="loading">
        <!-- 搜索框 -->
        <el-row class="searchRow">
          <el-col>
            <el-input
              :placeholder="$t('clientmanage.addDialog.placeholdertext')"
              v-model="roleName"
              clearable
              @clear="loadRoleList()"
              class="inputSearch"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchRole()"></el-button>
            </el-input>
            <el-button type="primary" @click="showAddrole()" class="search">{{
              $t('rolemanager.addRole')
            }}</el-button>
          </el-col>
        </el-row>

        <!-- 表格 -->
        <el-table
          :data="rolelist"
          style="width: 100%"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column type="index" label="#" width="60"> </el-table-column>

          <el-table-column prop="userName" :label="$t('accountmanager.userName')">
          </el-table-column>

          <el-table-column prop="remark" :label="$t('device.remark')"> </el-table-column>

          <el-table-column prop="" :label="$t('accountmanager.operation')">
            <template slot-scope="scope">
              <el-row>
                <el-popconfirm
                  :ref="`popover-${scope.row.id}`"
                  :key="scope.row.id"
                  :title="$t('orders.tip.danger')"
                  @confirm="showEditRole(scope.row)"
                >
                  <el-button slot="reference" type="primary" size="mini" icon="el-icon-edit">{{
                    $t('rolemanager.modiFicaTion')
                  }}</el-button>
                </el-popconfirm>
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-zoom-in"
                  @click="getRoles(scope.row)"
                >
                  {{ $t('rolemanager.View') }}
                </el-button>
                <el-popconfirm :title="$t('orders.tip.danger')" @confirm="getGoogleKey(scope.row)">
                  <el-button slot="reference" type="primary" size="mini" icon="el-icon-zoom-in">
                    {{ $t('accountmanager.checkKey') }}
                  </el-button>
                </el-popconfirm>

                <el-popconfirm
                  v-if="isDel"
                  :title="$t('orders.tip.danger')"
                  @confirm="handleDel(scope.row.id)"
                >
                  <el-button slot="reference" type="danger" size="mini" icon="el-icon-zoom-in">
                    {{ $t('btns.del') }}
                  </el-button>
                </el-popconfirm>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <v-pagination v-model="query" :total="total" @update="getRoleList" />
      </div>
      <!-- 弹出编辑角色对话框 -->
      <el-dialog :title="$t('rolemanager.compileRole')" :visible.sync="alterRole" width="50%">
        <div v-loading="alterloading">
          <el-form :model="form" ref="addform" :rules="rules">
            <el-form-item label="distributedId" :label-width="formLabelWidth" prop="distributedId">
              <template>
                <el-tree
                  ref="tree"
                  :data="gainRoleTowList"
                  show-checkbox
                  node-key="id"
                  :default-expanded-keys="defaultSelectedNodes"
                  :props="defaultProps"
                >
                </el-tree>
              </template>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelEditRole()">{{ $t('accountmanager.cancel') }}</el-button>
            <el-button type="primary" @click="editRole()">{{
              $t('accountmanager.confirm')
            }}</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 添加角色 -->
      <el-dialog
        :title="$t('rolemanager.addRole')"
        :visible.sync="showAddRole"
        class="customWidth"
        width="50%"
        @close="closeDialog"
      >
        <div v-loading="addloading">
          <el-form :model="addform" ref="form" :rules="rules">
            <el-form-item
              :label="$t('accountmanager.userName')"
              :label-width="formLabelWidth"
              prop="userName"
            >
              <el-input v-model="addform.userName" autocomplete="off" maxLength="20">
                <template slot="prepend">{{ info.companyPayName }}_</template>
              </el-input>
            </el-form-item>

            <el-form-item
              :label="$t('device.password')"
              :label-width="formLabelWidth"
              prop="password"
            >
              <el-input v-model.trim="addform.password" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item :label="$t('device.remark')" :label-width="formLabelWidth" prop="remark">
              <el-input v-model="addform.remark" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
              :label="$t('rolemanager.data.distributedId')"
              :label-width="formLabelWidth"
              prop="distributedId"
            >
              <template>
                <el-tree
                  ref="tree"
                  :data="gainRoleList"
                  show-checkbox
                  node-key="id"
                  :default-expanded-keys="checkedkeys"
                  :default-checked-keys="defaultId"
                  :props="defaultProps"
                >
                </el-tree>
              </template>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelAddMeun()">{{ $t('accountmanager.cancel') }}</el-button>
            <el-button type="primary" @click="addRole()">{{
              $t('accountmanager.confirm')
            }}</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 查看角色所有消息 -->
      <el-dialog :title="$t('rolemanager.checkRole')" :visible.sync="checkAllRole1" width="30%">
        <div class="deliverySetting-table" v-for="(item, idx) in gainRoleTowList" :key="idx">
          <div class="table-body" v-for="(pro, idx2) in item.childrenMenus" :key="idx2">
            <div class="first-col">
              <span
                v-if="idx2 == 0"
                style="display: inline-block; line-height: 30px; cursor: pointer"
              >
                <i
                  class="el-icon-check"
                  style="color: #3c763d; font-weight: 700"
                  v-if="item.have"
                ></i>
                <i class="el-icon-close" style="color: #e6a23c; font-weight: 700" v-else></i>
                <span v-if="$i18n.locale == 'zh'">{{ item.menuName }}</span>
                <span v-else>{{ item.menuNameVn }}</span>
              </span>
            </div>
            <div class="width120">
              <span style="display: inline-block; line-height: 30px; cursor: pointer">
                <i
                  class="el-icon-check"
                  style="color: #3c763d; font-weight: 700"
                  v-if="pro.have"
                ></i>
                <i class="el-icon-close" style="color: #e6a23c; font-weight: 700" v-else></i>
                <span v-if="$i18n.locale == 'zh'">{{ pro.menuName }}</span>
                <span v-else>{{ pro.menuNameVn }}</span>
              </span>
            </div>

            <div class="width265">
              <span v-for="c in pro.childrenMenus" :key="c.id">
                <i class="el-icon-check" style="color: #3c763d; font-weight: 700" v-if="c.have"></i>
                <i class="el-icon-close" style="color: #e6a23c; font-weight: 700" v-else></i>
                <template v-if="$i18n.locale == 'zh'">{{ c.menuName }}</template>
                <template v-else>{{ c.menuNameVn }}</template>
              </span>
            </div>
          </div>
        </div>
      </el-dialog>
      <!--      显示二维码-->
      <el-dialog :title="$t('sysConfig.hint')" :visible.sync="showCode" width="30%">
        <img :src="codeImg" alt="code" />
        <span slot="footer" class="dialog-footer">
          <el-button @click="showCode = false">{{ $t('btns.cancel') }}</el-button>
          <el-button type="primary" @click="showCode = false">{{ $t('btns.confirm') }}</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'rolemanager',
  data() {
    return {
      defaultId: [],
      //验证
      rules: {
        roleCode: [
          {
            required: true,
            message: this.$t('rolemanager.data.roleCode'),
            trigger: 'blur'
          }
        ],
        roleName: [
          {
            required: true,
            message: this.$t('rolemanager.data.roleName'),
            trigger: 'blur'
          }
        ],
        menuNameVn: [
          {
            required: true,
            message: this.$t('menumanage.data.checkmenuNameVn'),
            trigger: 'blur'
          }
        ]
      },
      //添加角色
      showAddRole: false,
      // current默认第几页
      //size每页条数
      query: {
        no: 1,
        size: this.$defaultPaginationSize
      },
      roleName: '',
      rolelist: [], //list数据
      total: -1, //分页总数
      loading: false, //遮罩层
      alterloading: false,
      addloading: false,
      formLabelWidth: '100px',
      alterRole: false, //修改角色弹窗
      checkAllRole: false, //查看角色所有信息
      checkAllRole1: false,
      form: {
        // password: '',
        // userName: '',
        // createAcct: '',
        // remark: '',
        updateTime: ''
      },
      //添加角色
      addform: {
        password: '',
        userName: '',
        remark: '',
        childrenMenus: []
      },
      gainRoleList: [],
      gainRoleTowList: [],
      checkedkeys: [], //默认张开树状图
      defaultSelectedNodes: [], //修改默认展开
      defaultProps: {
        children: 'childrenMenus',
        label: 'label',
        id: 'id'
      },
      roleId: {
        roleId: ''
      },
      showCode: false,
      codeImg: ''
    };
  },
  computed: {
    ...mapGetters(['permission']),
    isDel() {
      return this.permission.includes('merchant:subAccount:delete');
    },
    info() {
      return this.$store.state.user.info;
    }
  },
  created() {
    this.getRoleList();
  },
  methods: {
    closeDialog() {
      //清空数据
      this.addform = {
        password: '',
        userName: '',
        remark: '',
        childrenMenus: []
      };
    },
    //取消添加按钮
    cancelAddMeun() {
      //添加角色对话框
      this.showAddRole = false;
      //清空数据
      this.addform = {
        password: '',
        userName: '',
        remark: '',
        childrenMenus: []
      };
      //查看角色所有消息
      this.checkAllRole = false;
      // this.$refs.addform.resetFields();
    },
    //取消修改按钮
    cancelEditRole() {
      // console.log(1111);
      this.defaultSelectedNodes.length = 0;
      // console.log(this.defaultSelectedNodes);
      //关闭编辑角色对话框
      this.alterRole = false;
      this.$refs.addform.resetFields();
    },

    // 获取tree半选中和全选中节点
    checkedNode() {
      let arr1 = this.$refs.tree.getCheckedKeys();
      let arr2 = this.$refs.tree.getHalfCheckedKeys();
      let arr = [...arr1, ...arr2];
      if (arr.length == 0) {
        this.$message.error(this.$t('rolemanager.data.distributedId'));
        return false;
      }
      this.addform.childrenMenus.length = 0;

      for (var a = 0; a < arr.length; a++) {
        //console.log(arr[a])   2132112  211231   12123131   123132131
        this.addform.childrenMenus.push({
          distributedId: arr[a],
          have: true
        });
      }
      return true;
    },
    resetAddFrom() {
      this.addform = {
        password: '',
        userName: '',
        remark: '',
        childrenMenus: []
      };
    },
    //确定添加角色
    async addRole() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return this.$message.error(this.$t('rolemanager.data.addRoleError'));
        const _Node = this.checkedNode();
        if (!_Node) {
          return false;
        }
        let param = {
          password: this.addform.password,
          remark: this.addform.remark,
          userName: `${this.info.companyPayName}_${this.addform.userName}`,
          roleMenuDto: {
            childrenMenus: this.addform.childrenMenus
          }
        };
        this.loading = true;
        const res = await this.$http.post('/merchant/subAccount/add', param);
        if (res.data.code !== 200) return;
        this.showAddRole = false;
        this.loading = false;
        this.getRoleList();
        if (res.data.code != 200) return this.$message.error(res.data.msg);
        this.resetAddFrom();
      });
    },
    //添加角色按钮
    async showAddrole() {
      this.showAddRole = true;
      this.addloading = true;
      const res = await this.$http.get('/merchant/subAccount/treeMenu');
      this.gainRoleList = this.getMenuTreeToList(res.data.data || []);
      this.defaultId = ['1374957938096648192'];
      for (var a = 0; a < this.gainRoleList.length; a++) {
        this.checkedkeys.push(this.gainRoleList[a].id);
      }
      this.getRoleList();
      this.addloading = false;
    },
    //查看所有角色消息
    showRole(row) {
      this.checkAllRole1 = true;
      this.form = row;
      // console.log(row);
    },

    //确定修改角色
    editRole() {
      this.$refs.addform.validate(async (valid) => {
        if (!valid) return this.$message.error(this.$t('rolemanager.data.changRoleError'));
        this.alterRole = false;
        this.checkedNode();
        let param = {
          id: this.form.id,
          roleId: this.form.roleId,
          roleMenuDto: {
            childrenMenus: this.addform.childrenMenus
          }
        };
        this.loading = true;
        const res = await this.$http.post('/merchant/subAccount/update', param);
        this.loading = false;
        if (res.data.code == 200) {
          this.getRoleList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getMenuTreeToList(menuTree) {
      //--------加一个属性lable--menuName==》label显示---------
      const label = this.$i18n.locale == 'zh' ? 'menuName' : 'menuNameVn';
      function getChild(tree) {
        for (var i = 0; i < tree.length; i++) {
          if (tree[i].childrenMenus.length > 0) {
            getChild(tree[i].childrenMenus);
          }
          tree[i].label = tree[i][label];
        }
      }
      getChild(menuTree);
      return menuTree;
    },
    async getRoles(row) {
      this.showRole(row);
      const { data } = await this.$http.get(
        '/merchant/subAccount/subMenuTreeList?userId=' + row.distributedId,
        {}
      );
      if (data) {
        if (data.code === 200) {
          this.gainRoleTowList = this.getMenuTreeToList(data.data || []);
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    async handleDel(id) {
      const { data } = await this.$http.post('/merchant/subAccount/delete', { id });
      if (data) {
        if (data.code === 200) {
          this.searchRole();
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    // 获取谷歌密钥
    async getGoogleKey(row) {
      const { data } = await this.$http.get(
        '/merchant/subAccount/getGoogleCode?userName=' + row.userName,
        {}
      );
      if (data) {
        if (data.code === 200) {
          this.codeImg = data.data.secretQr;
          this.showCode = true;
        } else {
          this.$message.error(data.msg);
        }
      }
    },

    //修改角色按钮
    async showEditRole(row) {
      //清空节点
      this.defaultSelectedNodes.length = 0;
      this.form = row;
      this.alterRole = true;
      this.alterloading = true;
      this.roleId.roleId = row.distributedId;
      var res = await this.$http.get(
        '/merchant/subAccount/subMenuTreeList?userId=' + row.distributedId,
        {}
      );
      if (res.data.code != 200) {
        this.$message.error(res.data.msg);
        return;
      }
      this.gainRoleTowList = this.getMenuTreeToList(res.data.data);

      function findSelectedNodes(data, list) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].childrenMenus && data[i].childrenMenus.length == 0 && data[i].have == true) {
            list.push(data[i].id);
          }
          if (data[i].childrenMenus && data[i].childrenMenus.length > 0) {
            findSelectedNodes(data[i].childrenMenus, list);
          }
        }
      }
      findSelectedNodes(res.data.data, this.defaultSelectedNodes);
      this.$refs.tree.setCheckedKeys(this.defaultSelectedNodes);
      this.alterloading = false;
    },

    //根据角色名称搜索
    searchRole() {
      if (this.query.roleName == '') {
        this.$message.error(this.$t('rolemanager.inputNull'));
        return;
      }
      this.getRoleList();
    },
    //清空搜索框
    loadRoleList() {
      this.getRoleList();
    },
    //获取角色列表
    async getRoleList() {
      this.loading = true;
      let res = await this.$http.post('/merchant/subAccount/list/page', {
        query: {
          roleName: this.roleName
        },
        no: this.query.current,
        size: this.query.size
      });
      // console.log('角色id');
      // console.log(res);
      this.loading = false;
      if (res.data.code == 200) {
        this.rolelist = JSON.parse(JSON.stringify(res.data.data.list));
        localStorage.setItem('rolestorage', JSON.stringify(this.rolelist));
        this.total = res.data.data.rows;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.width120 {
  margin-left: 40px;
}

.width265 {
  margin-left: 120px;
  margin-bottom: 8px;
  display: flex;
  flex-wrap: wrap;
  grid-template-rows: auto;
  grid-template-columns: repeat(auto-fit, minmax(100px, 200px));
  grid-column-gap: 10px;
  grid-row-gap: 4px;
}
.inputSearch {
  width: 300px;
}

.box-card,
.table,
.pag {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/childrenlist/index.vue